import { render, staticRenderFns } from "./areaMyProducts.vue?vue&type=template&id=218e4c3c"
import script from "./areaMyProducts.vue?vue&type=script&lang=js"
export * from "./areaMyProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports